"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _reactBootstrap = require("react-bootstrap");

require("./button.scss");

var Button = _reactBootstrap.Button;
exports.Button = Button;